import { render, staticRenderFns } from "./need-detail-solution.vue?vue&type=template&id=5f27b0ca&scoped=true&"
import script from "./need-detail-solution.vue?vue&type=script&lang=js&"
export * from "./need-detail-solution.vue?vue&type=script&lang=js&"
import style0 from "./need-detail-solution.vue?vue&type=style&index=0&id=5f27b0ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f27b0ca",
  null
  
)

export default component.exports